import { render, staticRenderFns } from "./BillDeliveryInfo.vue?vue&type=template&id=23528f04&"
import script from "./BillDeliveryInfo.vue?vue&type=script&lang=js&"
export * from "./BillDeliveryInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports